<script setup>
import { useConfiguratorStore } from '../../stores/configurator';
import { useUiStore } from '../../stores/ui.js';
import Intro from './Intro.vue';
import Layers from './Layers.vue';
import Logo from './Logo.vue';
import Navigation from './Navigation.vue';

const configurationStore = useConfiguratorStore();
const uiStore = useUiStore();
</script>

<template>
    <div>
        <div class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-overflow-hidden">
            <div class="tw-absolute tw-z-20 tw-flex tw-flex-col tw-text-white tw-justify-between tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-px-4 md:tw-px-5 xl:tw-px-16 xxl:tw-px-24 tw-pt-4.5 md:tw-pt-5 xl:tw-pt-12 xxl:tw-pt-20 tw-pb-8 md:tw-pb-16 lg:tw-pb-16 xl:tw-pb-28 xxl:tw-pb-40">
                <Logo />
                <Intro v-if="uiStore.currentStepIndex === 0" />
            </div>

            <Navigation />
            <Layers />
        </div>
    </div>
</template>
